var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/FolderGroup.tsx";
import React from 'react';
import { createSvgIcon } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FolderGroup = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("rect", {
    width: "24",
    height: "24",
    rx: "4",
    fill: "#4C5ECF"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2144 10.6436L12.9595 14.7325C12.3998 15.1756 11.6069 15.1756 11.0472 14.7403L5.79224 10.6514C5.39578 10.3405 5.39578 9.73412 5.79224 9.42317L11.0472 5.32649C11.6147 4.89117 12.3998 4.89117 12.9595 5.32649L18.2144 9.4154C18.6109 9.72634 18.6109 10.3327 18.2144 10.6436ZM11.5138 17.0802C11.7936 17.2978 12.1901 17.2978 12.4699 17.0802L17.2507 13.3566C17.5294 13.139 17.9204 13.139 18.1991 13.3566L18.2068 13.3644C18.6033 13.6753 18.6033 14.2739 18.2068 14.5849L12.9519 18.6738C12.3844 19.1091 11.5993 19.1091 11.0396 18.6738L5.78464 14.5849C5.38819 14.2739 5.38819 13.6753 5.78464 13.3644C6.06331 13.1468 6.45436 13.1468 6.73302 13.3644L11.5138 17.0802Z",
    fill: "white"
  })]
}), 'FolderGroup');